import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";

import { parseCustomQueryString } from '../common/utils/urlUtils'
import { axiosPost } from "../services/axios/apiCalls";
import AxiosError from "../components/modals/axiosErrorModal";
import SuccessModal from "../components/modals/successModal"
import CardChangePass from "../components/login/cardChangePass";

export default function AdministrativeChange({ systemData }) {
    /** MESSAGE STATUS */
    const [status, setStatusError] = useState(null);
    const [messageError, setMessageError] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);

    const [messageSuccess, setMessageSuccess] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    /** CONST */
    const navigate = useNavigate();
    const [allowedCode, setAllowedCode] = useState(false)
    const [accessCodeState, setAccessCodeState] = useState(null);
    const [usernameState, setUsernameState] = useState(null);

    const backgroundImageStyle = {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'white',
    };

    /** Funciones para manejar modals de error y success */
    const handleOpenErrorModal = (status, message) => {
        setStatusError(status);
        setMessageError(message);
        setShowErrorModal(true);
    };

    const handleCloseErrorModal = () => {
        setShowErrorModal(false);
        setStatusError(null);
    };

    const handleOpenSuccessModal = (message) => {
        setMessageSuccess(message);
        setShowSuccessModal(true);
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        navigate('/')
    };


    /** Recuperar datos del access code */
    const fetchAccessCodeData = async (domain, accessCode) => {
        const url = '/password/check'

        const response = await axiosPost(url, { domain, accessCode })

        if (response.status === 200) {
            setAccessCodeState(accessCode)
            setUsernameState(response.data.username)
            setAllowedCode(true)
        } else {
            handleOpenErrorModal(response.status, response.message)
        }
    }

    useEffect(() => {
        const urlParams = parseCustomQueryString(window.location.search);
        fetchAccessCodeData(urlParams[0], urlParams.unique_key)
    }, [systemData])

    return (
        <div className="" style={backgroundImageStyle}>
            <Container className="d-flex justify-content-center" component="main">
                {allowedCode &&
                    <CardChangePass
                        systemData={systemData}
                        accessCode={accessCodeState}
                        username={usernameState}
                        titleText="Cambio de contraseña" />
                }
            </Container>
            <AxiosError
                open={showErrorModal}
                onClose={handleCloseErrorModal}
                status={status}
                message={messageError} />
            <SuccessModal
                open={showSuccessModal}
                onClose={handleCloseSuccessModal}
                message={messageSuccess}
            />
        </div>
    );
}
